import { TagStatus } from '@arhs-fleetback/types/entities/tags';
import { createSelector } from 'reselect';

import type { MayBe } from 'modules/global/typing/common/common';
import { getSelectedGroupId } from 'modules/groups/selectors';
import { DashboardTypeEnum } from 'modules/tags/constants';
import { getUIState, getTagByIds } from 'modules/tags/selectors';
import { getSelectedDealerGroupId, getSelectedDealerId } from 'selectors/dealerSelectors';
import { getProps, getRoot, getSecondProps } from 'utils/selectors';

const getDashboardUIState = createSelector(getUIState, state => state.dashboard);

const getLoadingState = createSelector(getDashboardUIState, state => state.loading);

const getDeletingTagIds = createSelector(getLoadingState, state => state.delete);

const getDuplicatingTagIds = createSelector(getLoadingState, state => state.duplicate);

export const getFilters = createSelector(getDashboardUIState, state => state.filters);

export const isTagDeleting = createSelector(getDeletingTagIds, getProps<string>, (deletingIds, tagId) =>
  deletingIds.includes(tagId));

export const isTagDuplicating = createSelector(getDuplicatingTagIds, getProps<string>, (duplicatingIds, tagId) =>
  duplicatingIds.includes(tagId));

const getTableState = createSelector(
  getDashboardUIState,
  getProps<DashboardTypeEnum>,
  (state, source = DashboardTypeEnum.DEALER) => state[source]
);

const getTableTagIds = createSelector(getTableState, state => state.ids);

export const getTableTags = createSelector(getRoot, getTableTagIds, getTagByIds);

export const getTablePage = createSelector(getTableState, state => state.page);

export const isTableLoading = createSelector(getTableState, state => state.loading);

export const getBaseRequestParams = createSelector(
  getSecondProps<MayBe<string>>,
  getSelectedDealerId,
  getSelectedGroupId,
  getSelectedDealerGroupId,
  getFilters,
  getProps<DashboardTypeEnum>,
  (mode, dealerId, groupId, dealerGroupId, filters, source = DashboardTypeEnum.DEALER) => ({
    mode,
    status: [TagStatus.ACTIVE, TagStatus.INACTIVE],
    ...(source === DashboardTypeEnum.DEALER ? { dealerId } : { groupId: groupId || dealerGroupId }),
    ...filters,
  })
);
